import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

const OrganizationPending: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.statusIcon}>
          <img src="/assets/images/svg/pending.svg" alt="" width={64} height={64} />
        </div>
        <h2 className={styles.title}>{t("lbl_org_pending_title")}</h2>
        <p className={styles.subtitle}>{t("lbl_org_pending_subtitle")}</p>
      </div>
    </div>
  );
};

export default OrganizationPending;
